import { render } from "./FormBuilderView.vue?vue&type=template&id=a397175e&scoped=true"
import script from "./FormBuilderView.vue?vue&type=script&lang=js"
export * from "./FormBuilderView.vue?vue&type=script&lang=js"

import "./FormBuilderView.vue?vue&type=style&index=0&id=a397175e&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a397175e"]])

export default __exports__